import React from 'react';

const HjemlaLogo = ({ width = '100%', height = '100%', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinejoin="round"
      strokeWidth="1.333"
      d="M2.556 6.016c-.172-.079-.262-.111-.431-.093-.226.024-.246.056-.438.184l6.06-4.032c.151-.1.348-.1.499 0l6.015 3.976c.253.168.406.451.406.755v6.3c0 .358-.4.574-.7.377L2.556 6.016z"
    />
    <path
      stroke="#fff"
      strokeWidth="1.333"
      d="M1.333 6.808v6.297c0 .36.4.576.7.379l5.963-3.9L2.547 6.01c-.565-.302-1.214.21-1.214.798z"
    />
  </svg>
);

export default HjemlaLogo;
